import type { SecuredCookiesService } from "../../../shared/core/net/secured-cookies-service";

export class WebSecuredCookiesService implements SecuredCookiesService {
  getSecuredCookies(): boolean {
    return false;
  }
}
